import React, { useState } from "react"
import { Link } from "gatsby"
import Img from "gatsby-image"

const IconFactory = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 20h20" /><path d="M9 20V10l-5 5V7l7-5 7 5v8l-5-5v10" />
  </svg>
)

const IconFile = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /><line x1="10" y1="9" x2="8" y2="9" />
  </svg>
)

const TABS = [
  {
    key: "industries",
    Icon: IconFactory,
    title: "Industries",
    desc: "Sectors we specialise in serving",
    bg: "#eff6ff",
    ic: "#1b2d8e",
    centerLabel: "Industries We Serve",
    links: [
      { label: "Retail" },
      { label: "Manufacturing" },
      { label: "Distribution" },
      { label: "Education" },
      { label: "Travel" },
      { label: "Healthcare" },
    ],
  },
  {
    key: "case-studies",
    Icon: IconFile,
    title: "Case Studies",
    desc: "Real-world project success stories",
    bg: "#fff7ed",
    ic: "#ea580c",
    centerLabel: "Client Success Stories",
    links: [
      { to: "/caseStudies/projects/muscatMediaGroup",      label: "Muscat Media Group HR System" },
      { to: "/caseStudies/projects/orangelinePakistan",    label: "Orangeline Pakistan Construction" },
      { to: "/caseStudies/projects/bigJerrysFencing",      label: "Big Jerry's Fencing Digital Transformation" },
      { to: "/caseStudies/projects/nurturefulPsychology",  label: "Nurtureful Psychology Digital Transformation" },
      { to: "/caseStudies/projects/emeAquaticSystems",     label: "EME Aquatic Systems Procurement & Finance" },
    ],
  },
]

const OurPrimaryFocus = ({ queryData }) => {
  const [active, setActive] = useState("industries")
  // Both tabs render, so each panel reads its own TABS entry and `active` only
  // decides which is displayed.

  return (
    <div className="mega-menu">
      {/* Left: focus area tabs */}
      <div className="mega-menu__left">
        <p className="mega-menu__section-label">Focus Areas</p>
        {TABS.map(({ key, Icon, title, desc, bg, ic }) => (
          <button
            key={key}
            className={`mega-menu__nav-item${active === key ? " is-active" : ""}`}
            onClick={() => setActive(key)}
          >
            <div className="mega-menu__nav-icon" aria-hidden="true" style={{ background: bg }}>
              <Icon style={{ color: ic }} />
            </div>
            <div className="mega-menu__nav-text">
              <strong>{title}</strong>
              <span>{desc}</span>
            </div>
          </button>
        ))}
      </div>

      {/* Center: BOTH TABS' CONTENT, one displayed.
          The default tab is Industries, whose entries carry no `to` and are not
          links at all — so the five case-study links behind the second tab were
          absent from the markup until two clicks in. Both panels render now. */}
      <div className="mega-menu__center">
        {TABS.map(t => (
          <div
            key={t.key}
            className={`mega-menu__tabpanel${active === t.key ? " is-active" : ""}`}
          >
            <p className="mega-menu__section-label">{t.centerLabel}</p>
            <div className="mega-menu__grid">
              {t.links.map(({ to, label }) =>
                to ? (
                  <Link key={label} to={to} className="mega-menu__link">
                    <div className="mega-menu__link-icon" aria-hidden="true" style={{ background: t.bg, color: t.ic }}>→</div>
                    {label}
                  </Link>
                ) : (
                  <div key={label} className="mega-menu__link" style={{ cursor: "default" }}>
                    <div className="mega-menu__link-icon" aria-hidden="true" style={{ background: t.bg, color: t.ic }}>→</div>
                    {label}
                  </div>
                )
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Right: What's Latest */}
      <div className="mega-menu__right">
        <p className="mega-menu__section-label">What's Latest</p>
        <div className="mega-menu__featured-img">
          <Img fluid={queryData.perimflowForMenu.childImageSharp.fluid} alt="PerimFlow" />
        </div>
        <p className="mega-menu__featured-desc">
          PerimFlow – a fencing automation solution simplifying project management, quoting, and operations for fencing contractors.
        </p>
        <a href="https://perimflow.com/" target="_blank" rel="noopener noreferrer" className="mega-menu__cta-link">Visit PerimFlow →</a>
      </div>
    </div>
  )
}

export default OurPrimaryFocus
